import React from "react";
import { Link } from "react-router-dom";
import EntityPage from "@/components/EntityPage";
import Pill from "@/components/Pill";
import { useRefData } from "@/context/RefDataContext";

export default function IssuesPage() {
  const ref = useRefData();
  const lookup = (list, id) => list?.find((x) => x.value === id)?.label || "—";

  const columns = [
    {
      key: "code",
      label: "Ticket ID",
      render: (i) => (
        <Link
          to={`/issues/${i.id}`}
          className="font-mono text-xs text-sky-400 hover:underline"
          data-testid={`issues-code-${i.id}`}
        >
          {i.code}
        </Link>
      ),
    },
    {
      key: "subject",
      label: "Subject",
      render: (i) => (
        <Link
          to={`/issues/${i.id}`}
          className="text-white hover:text-sky-300 transition-colors"
          data-testid={`issues-subject-${i.id}`}
        >
          {i.subject}
        </Link>
      ),
    },
    { key: "project_id", label: "CDARK", render: (i) => <span className="text-zinc-400 text-xs">{lookup(ref.projects, i.project_id)}</span> },
    { key: "asset_id", label: "Asset", render: (i) => <span className="text-zinc-400 text-xs">{i.asset_id ? lookup(ref.assets, i.asset_id) : "—"}</span> },
    { key: "service_id", label: "Service", render: (i) => <span className="text-zinc-400 text-xs">{i.service_id ? lookup(ref.services, i.service_id) : "—"}</span> },
    { key: "team_id", label: "Team", render: (i) => <span className="text-zinc-400 text-xs">{lookup(ref.teams, i.team_id)}</span> },
    { key: "priority", label: "Priority", render: (i) => <Pill kind="priority" value={i.priority} /> },
    { key: "status", label: "Status", render: (i) => <Pill kind="status" value={i.status} /> },
  ];

  const fields = [
    { key: "subject", label: "Subject", required: true, full: true },
    { key: "project_id", label: "CDARK (optional)", type: "select", optionsRef: "projects" },
    { key: "asset_id", label: "Asset Tagging (optional)", type: "select", optionsRef: "assets", filterBy: "project_id" },
    { key: "service_id", label: "Service Tagging (optional)", type: "select", optionsRef: "services", filterBy: "project_id" },
    { key: "priority", label: "Priority", type: "select", optionsRef: "priorities" },
    { key: "description", label: "Ticket Summary", type: "textarea", full: true },
    { key: "contact_persons", label: "Contacts", type: "contacts", full: true },
    { key: "files", label: "Attachments", type: "files", full: true },
  ];

  const initial = {
    subject: "",
    project_id: "",
    asset_id: "",
    service_id: "",
    priority: "Medium",
    description: "",
    contact_persons: [],
    files: [],
  };

  return (
    <EntityPage
      title="Tickets"
      subtitle="Problems and incidents that need resolution."
      testidPrefix="issues"
      endpoint="/issues"
      columns={columns}
      fields={fields}
      initialForm={initial}
      referenceData={ref}
    />
  );
}
